import documentService from '@services/documentService';

/**
 * Abre o arquivo numa nova aba. A aba é aberta ANTES da chamada à API (síncrona ao clique) para
 * não cair no bloqueador de pop-ups; depois recebe a URL SAS de leitura (inline).
 */
export const openDocumentInNewTab = async (id: number): Promise<void> => {
  const tab = window.open('', '_blank');
  try {
    const { url } = await documentService.getUrl(id);
    if (tab) {
      tab.opener = null;
      tab.location.href = url;
    } else {
      window.open(url, '_blank', 'noopener');
    }
  } catch (err) {
    tab?.close();
    throw err;
  }
};

/** Baixa o arquivo (SAS com `Content-Disposition: attachment` e o nome original). */
export const downloadDocument = async (id: number): Promise<void> => {
  const { url } = await documentService.getUrl(id, true);
  const a = document.createElement('a');
  a.href = url;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
};
